export default "__VITE_PUBLIC_ASSET__60630c1e__"